import { Clickable, Icon, Row, Text } from 'components';
import { useOutsideClick } from 'core';
import { theme } from 'lib';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: absolute;
  width: 296px;
  padding: 12px 0;
  background-color: #fff;
  right: 24px;
  top: -24px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.2);
  z-index: 1;
`;

const ShareItem = ({ text, icon, onClick, dimensions }) => {
  return (
    <Clickable onClick={onClick} goThrough>
      <Row wid="calc(100% - 32px)" pad="12px 16px" center>
        <Row wid="24px" ht="24px" centerAll>
          <Icon type={icon} col={theme.GREY_60} dimensions={dimensions} />
        </Row>

        <Text marg="0 0 0 8px">{text}</Text>
      </Row>
    </Clickable>
  );
};

const ShareModal = ({ post, visible, handleClose }) => {
  const ref = useRef(null),
    { t } = useTranslation(),
    emailSubject = 'Check out this post on P4P';

  let link = post?.dynamicLink;

  if (
    post.dynamicLink &&
    (post.dynamicLink.includes('page.link') || !post.dynamicLink.includes('/shared/profile/'))
  ) {
    link = `https://playaz4playaz.com/shared/profile/${encodeURIComponent(post?.owner?.username)}/post/${post?._id}`;
  }

  useOutsideClick(ref, handleClose);

  function shareToFacebook() {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${link}`);
  }

  function shareToTwitter() {
    window.open(`https://twitter.com/share?url=${link}`);
  }

  function shareToWhatsapp() {
    window.open(`https://api.whatsapp.com/send?text=${link}`);
  }

  function shareToTelegram() {
    window.open(`https://telegram.me/share/url?url=${link}`);
  }

  function shareToEmail() {
    window.open(`mailto:?subject=${emailSubject}&body=${link}`);
  }

  function copyLink() {
    navigator.clipboard.writeText(link);
    handleClose();
  }

  return (
    <Wrapper ref={ref}>
      {/*
        <ShareItem
          text={t('share.repost')}
          icon='repost' dimensions={18}
        />
      */}

      {/*
        <ShareItem
          text={t('share.viaMessage')}
          icon='sendOutline'
          dimensions={21}
        />
      */}

      <ShareItem text={t('share.toFb')} icon="facebook" dimensions={24} onClick={shareToFacebook} />

      {/*
        <ShareItem
          text={t('share.toInst')}
          icon='instagram'
          dimensions={24}
        />
      */}

      <ShareItem text={t('share.toTwit')} icon="twitter" dimensions={24} onClick={shareToTwitter} />

      <ShareItem
        text={t('share.toWhapp')}
        icon="whatsApp"
        dimensions={24}
        onClick={shareToWhatsapp}
      />

      <ShareItem
        text={t('share.toTelg')}
        icon="telegram"
        dimensions={24}
        onClick={shareToTelegram}
      />

      <ShareItem
        text={t('share.viaEmail')}
        icon="emailNotification"
        dimensions={20}
        onClick={shareToEmail}
      />

      <ShareItem text={t('share.copyLink')} icon="link" dimensions={20} onClick={copyLink} />
    </Wrapper>
  );
};

export default ShareModal;
